import { BCMSCurrency, useModel } from "@bcm-dev/bcms-vite";
import React, { useEffect, useState } from "react";
import "./styles.css";

export  default function UIAmountInput(props) {
    const { branding } = useModel();

    const fixedInput = branding.options.amount_field_ui_rxp22 !== "Free-Form"; 
    
    return fixedInput ? <UIAmountInputFixed {...props}/>:<UIAmountInputFree {...props}/>;
}
/**
 * @function UIAmountInput
 * @param {STRING} placeHolder - The placeholder that should be shown when no value is in the field
 * @param {STRING} className - Additional class that can be added
 * @param {STRING} value - The value that should be set in the field
 * @param {FUNCTION} onChange - Function to be ran when the value in the field is updated
 * @return {React.Component}
 * @example <UIAmountInput value="1.23" onChange={ value => { ... } } />
 */
export  function UIAmountInputFixed(props) {
    const className = props.className ?? "";
    const dataPoint = props.dataPoint ? { "data-point": props.dataPoint } : {};

    const [ state, setState ] = useState(props.value ?? "");
    const inputField = React.createRef();

    const onChange = evt => {
        // Remove dollar sign
        let value = inputField.current.value;
        //value = value.replace(/[$a-zA-Z\,]/g, "");
        value = value.replace(/[^0-9\.]/g, "");

        if(evt.nativeEvent.inputType === "deleteContentBackward") {
            value = state.replace(/[^0-9]/g, "");
            value = value.slice(0, value.length - 1);
            
            value = `${ value.slice(0, value.length - 2) }.${ value.slice(value.length - 2, value.length) }`;
        }

        // Get the cents from the value
        const getCents = amount => {
            if(amount.indexOf(".") !== -1) {
                const cents = amount.split(".")[1];
                
                if(cents.length > 2) { return `${ cents.slice(0, -2) }.${ cents.slice(-2) }`; }
                else { return cents.length === 1 ? `.${ cents }` : `.${ cents }` }
            } else { return "00"; }
        };

        if(value !== "other") {
            if(value.indexOf(".") !== -1) {
                const cents = getCents(value);
                const dollars = value.split(".")[0];

                setState(BCMSCurrency.toCurrency(`${ dollars }${ cents }`));

                if(props.onChange instanceof Function) {
                    props.onChange(`${ dollars }${ cents }`);
                }
            }
            else {
                setState(BCMSCurrency.toCurrency(`.0${ value }`));
                
                if(props.onChange instanceof Function) {
                    props.onChange(`.0${ value }`);
                }
            }
        }
    };

    useEffect(() => setState(props.value ?? ""), [ props.value ]);

    return (
        <div className={`form-row flex-height uitextinput ui-amount-input ${className}`}>
            <div className="floating-label-input-container">
                <input className="floating-label-input form-row-input" ref={ inputField } type="text" placeholder=" " value={ state } onChange={ onChange } { ...dataPoint }></input>
                <label className="floating-label form-row-label">{props.placeHolder}</label>
            </div>
            <span className="form-row-info-text gray-text">
                {props.children}
            </span>
        </div>
    );
}
export function UIAmountInputFree(props) {
    const className = props.className ?? "";
    const dataPoint = props.dataPoint ? { "data-point": props.dataPoint } : {};
    const [ state, setState ] = useState(props.value ?? "");
    const inputField = React.createRef();

    const onChange = evt => {
        // Remove dollar sign
        let value = inputField.current.value;
        //value = value.replace(/[$a-zA-Z\,]/g, "");
        value = value.replace(/[^0-9\.]/g, "");
        if(value.indexOf(".") == -1) {
            value = value+".00"
        }
        if(evt.nativeEvent.inputType === "deleteContentBackward") {
            value = state.replace(/[^0-9]/g, "");
            value = value.slice(0, value.length - 1);
            
            value = `${ value.slice(0, value.length - 2) }.${ value.slice(value.length - 2, value.length) }`;
        }

        // Get the cents from the value
        const getCents = amount => {
            if(amount.indexOf(".") !== -1) {
                const cents = amount.split(".")[1];
                
                if(cents.length > 2) { return `${ cents.slice(0, -2) }.${ cents.slice(-2) }`; }
                else { return cents.length === 1 ? `.${ cents }` : `.${ cents }` }
            } else { return "00"; }
        };

        if(value !== "other") {
            if(value.indexOf(".") !== -1) {
                const cents = getCents(value);
                const dollars = value.split(".")[0];

                setState(BCMSCurrency.toCurrency(`${ dollars }${ cents }`));

                if(props.onChange instanceof Function) {
                    props.onChange(`${ dollars }${ cents }`);
                }
            }
            else {
                setState(BCMSCurrency.toCurrency(`.0${ value }`));
                
                if(props.onChange instanceof Function) {
                    props.onChange(`.0${ value }`);
                }
            }
        }
    };
let onChange2 = evt => {
    let value = inputField.current.value;
    value = value.replace(/[^0-9\.]/g, "");
    let validCents =value.split('.');    
     if(validCents ){
        if( validCents.length < 3){
            if(validCents[1] ==undefined){
                setState("$"+value, "") 
            }else{  
                   if(validCents[1].length <=2){
                    setState("$"+value, "") 
                   }
                      
            }
        }  
    }else{
        setState("$"+value, "") 
    }
    
}
    useEffect(() => setState(props.value ?? ""), [ props.value ]);

    return (
        <div className={`form-row flex-height uitextinput ${className}`}>
            <div className="floating-label-input-container">
                <input className="floating-label-input form-row-input" ref={ inputField } type="text" placeholder=" " value={state} onChange={onChange2} onBlur={onChange} { ...dataPoint }></input>
                <label className="floating-label form-row-label">{props.placeHolder}</label>
            </div>
            <span className="form-row-info-text gray-text">
                {props.children}
            </span>
        </div>
    );
}